import React, { useEffect, useState } from "react";
import { Grid, Button, Paper, useMediaQuery, Box, Modal } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky";
import { 
  fcheck_null_undefine_replace_empty,
} from "../../../Utility/Utilitys";
import { 
  Stock_Enquiry_All_Loc_Stock,
} from "../../../Server/ApiV2";
 
const GCStockDetail = ({
  open = false,
  fCloseSearchModal = () => {},
  xTitle = "Stock Enquiry",
  v_itmCd="",
}) => {
  const vMediaQuery = useMediaQuery("(max-width:650px)");

  const [rows, setRows] = useState([]);
 
  
  const [columns,setcolumn] =useState( [
    {
      field: "UId",
      headerName: "Sr.No",
      width: 100,
      hide:true
     
    },
    {
      field: "Name1",
      headerName: "Name",
      width:200,
    },
    {
      field: "StkQty",
      headerName: "StkQty",
      width: 100,
      
    },
  ]);
 
  const handleLoad = async (v_itmCd) => { 
    const payload = { 
      ItmCd: v_itmCd || "", 
    };
    let resp = await Stock_Enquiry_All_Loc_Stock(
      fcheck_null_undefine_replace_empty(payload)
    ); 
    if (resp?.status === 200) {
      console.log(resp);
      let {recordset} = resp?.data;

      setRows(recordset);
    } else {
      setRows([]);
      
    }

  
  };
  useEffect(() => {
    if (open) {
      handleLoad(v_itmCd);
    }
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={()=>{
        setRows([]);
        fCloseSearchModal()
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="container-fluid">
        <Box sx={{ overflow: "auto" }} className="model-GCSearchBtn">
          <GCTitleSticky title={xTitle} onClose={()=>{
            setRows([]);
            fCloseSearchModal()
          }} />

          <Paper style={{ padding: "5px" }}>
            <Grid container spacing={2}>
               

              <Grid item xs={12}>
                <div
                  style={{
                    height: vMediaQuery ? "80vh" : "72vh",
                    width: "100%",
                  }}
                  id="table-main-grid-4"
                >
                  <DataGrid
                    rowHeight={30}
                    headerHeight={40}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "mui-even-row"
                        : "mui-odd-row"
                    }
                    sx={{
                      border: 1,
                      borderColor: "primary.light",
                      cursor: "pointer",
                    }}
                    rows={rows}
                    columns={columns}
                    getRowId={(row) => row.UId}                    
                    hideFooter={rows.length < 100}
                     
                  />
                </div>
              </Grid>
            </Grid>
          </Paper>
        </Box>
      </div>
    </Modal>
  );
};

export default GCStockDetail;
